import React from "react";
const MSummary = () => {
  return <div className="papaDiv">bacvfjb</div>;
};
export default MSummary;
